import img1 from "./images/shawn1.png";
import img2 from "./images/shatil.jpg";
import img3 from "./images/jhon.png";
import { AiFillGithub, AiFillLinkedin, AiFillFacebook, AiFillTwitterSquare } from "react-icons/ai";
const Data = [
  {
    id: 1,
    img: img1,
    name: "Shawn",
    title: "Software Engineer",
    university: "Southwest Forestry University",
    hobby:
      "Like to travel beautiful places, and love to eat delecious food, playing different types of game is one of the most important part of his life and so on.",
    links: [
      {icon: <AiFillGithub />, git: "https://github.com/Shawn102"},
      {icon: <AiFillLinkedin />, git: "https://www.linkedin.com/in/md-niamul-hakim-936948239/",},
      {icon: <AiFillFacebook />, git: "https://www.facebook.com/niamul102"}, 
      {icon: <AiFillTwitterSquare />, git: "https://www.twitter.com"}  
    ]
  },
  {
    id: 2,
    img: img2,
    name: "Shatil",
    title: "Front-end Developer",
    university: "Southwest Forestry University",
    hobby: "Like to travel beautiful places, and love to eat delecious food.",
    links: [
      {icon: <AiFillGithub />, git: "https://github.com/sshatil"},
      {icon: <AiFillLinkedin />, git: "www.linkedin.com",},
      {icon: <AiFillFacebook />, git: "https://www.facebook.com/ssshatil"},
      {icon: <AiFillTwitterSquare />, git: "https://www.twitter.com"}    
    ]
  },
  {
    id: 3,
    img: img3,
    name: "John",
    title: "Senior Software Engineer",
    university: "Western Governors University",
    hobby:
      "Love to teach codding others. Love to face different codding problem and solve that.",
    links: [
      {icon: <AiFillGithub />, git: "https://github.com/sshatil"},
      {icon: <AiFillLinkedin />, git: "www.linkedin.com"},
      {icon: <AiFillFacebook />, git: "https://github.com/john-smilga"},
      {icon: <AiFillTwitterSquare />, git: "https://www.twitter.com"}    
    ]
  } 
];
export default Data;
